module.exports = __webpack_public_path__ + "static/media/arrowYellow.67ced404.svg";